import { logger as N } from "../../shared-lib/index.js";
import { BANNERS_DISABLED_MESSAGE as v } from "../common/constants.js";
import r from "../managers/braze-instance.js";
import i from "./banner-provider-factory.js";
import { getBannerIfNotExpired as y } from "./get-banner.js";
export function getAllBanners() {
  if (!r.rr()) return;
  const n = {},
    o = r.v();
  if (
    (!1 === (null == o ? void 0 : o.zt()) && N.error(v),
    !(null == o ? void 0 : o.zt()))
  )
    return n;
  const t = i.m().dt();
  for (const r in t) n[r] = y(t, r);
  return n;
}
